
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entities"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRangeInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"globalDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entities"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audits"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountPerformed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountPlanned"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountNotContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountHalfContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountContent"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"inspections"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountPerformed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountPlanned"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountWithAnomalies"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountDeclined"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountAccepted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountExpired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountSold"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"anomalies"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountSoldDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountDemo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountRental"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountPiP"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":605}};
    doc.loc.source = {"body":"query GlobalDashboard(\n  $entities: [ID!]\n  $date: DateRangeInput\n) {\n  globalDashboard(\n    entities: $entities\n    date: $date\n  ) {\n    statistics {\n      audits {\n        amountPerformed\n        amountPlanned\n        amountNotContent\n        amountHalfContent\n        amountContent\n      }\n\n      inspections {\n        amountPerformed\n        amountPlanned\n        amountWithAnomalies\n        amountDeclined\n        amountAccepted\n        amountExpired\n        amountSold\n      }\n\n      anomalies {\n        amountSoldDate\n        amountDemo\n        amountRental\n        amountPiP\n      }\n    }\n  }\n}\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["GlobalDashboard"] = oneQuery(doc, "GlobalDashboard");
        
